// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  createCampaign,
  deleteCampaign,
  getDetailCampaign,
  getListCampaign,
  updateCampaign,
} from './campaignThunk';

export interface ICampaignState {
  isRefreshCampaignList: boolean;
}

export const initialState: ICampaignState = {
  isRefreshCampaignList: false,
};

const campaignSlice = createSlice({
  name: 'campaign',
  initialState,
  reducers: {
    setRefreshCampaignList(state, action) {
      state.isRefreshCampaignList = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET: Get campaign list
    builder
      .addCase(getListCampaign.pending, (_state) => {})
      .addCase(getListCampaign.fulfilled, (_state) => {})
      .addCase(getListCampaign.rejected, (_state) => {});

    // DELETE: Delete campaign
    builder
      .addCase(deleteCampaign.pending, (_state) => {})
      .addCase(deleteCampaign.fulfilled, (_state) => {})
      .addCase(deleteCampaign.rejected, (_state) => {});

    // POST: Create campaign
    builder
      .addCase(createCampaign.pending, (_state) => {})
      .addCase(createCampaign.fulfilled, (_state) => {})
      .addCase(createCampaign.rejected, (_state) => {});

    // GET: Get detail campaign
    builder
      .addCase(getDetailCampaign.pending, (_state) => {})
      .addCase(getDetailCampaign.fulfilled, (_state) => {})
      .addCase(getDetailCampaign.rejected, (_state) => {});

    // PUT: Update campaign
    builder
      .addCase(updateCampaign.pending, (_state) => {})
      .addCase(updateCampaign.fulfilled, (_state) => {})
      .addCase(updateCampaign.rejected, (_state) => {});
  },
});

// Action
export const campaignActions = campaignSlice.actions;

// Selectors
export const selectIsRefreshCampaignList = (state: RootState) => state.campaign.isRefreshCampaignList;

// Reducer
const campaignReducer = campaignSlice.reducer;
export default campaignReducer;
